import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    Input,
    OnInit,
    Renderer2,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { FiInfoIconMode } from '@fi-shared/info-icon/info-icon.component';
import { IChecklistStatusProgressData } from '@fi-shared/checklist/checklist-v2';

@Component({
    selector: 'fi-checklist-status-row',
    template: `
        <div class="checklist-status-progress-bar-container">
          <div class="checklist-status-item completed" #completedEl>
            @if (isTooltipAvailable) {
              <fi-info-icon
                [mode]="FiInfoIconMode.WithoutIconAbsolute"
                fiInfoPosition="top"
                tooltipClass="fi-rounded-white-tooltip"
                tooltipTextAlignment="center"
                [isIconTooltipShown]="false"
                >
                <span [innerHTML]="checklistStatusData.completedCount"></span>
              </fi-info-icon>
            }
          </div>
        
          <div class="checklist-status-item in-progress" #inProgressEl>
            @if (isTooltipAvailable) {
              <fi-info-icon
                [mode]="FiInfoIconMode.WithoutIconAbsolute"
                fiInfoPosition="top"
                tooltipClass="fi-rounded-white-tooltip"
                tooltipTextAlignment="center"
                [isIconTooltipShown]="false"
                >
                <span [innerHTML]="checklistStatusData.inProgressCount"></span>
              </fi-info-icon>
            }
          </div>
        
          <div class="checklist-status-item not-started" #notStartedEl>
            @if (isTooltipAvailable) {
              <fi-info-icon
                [mode]="FiInfoIconMode.WithoutIconAbsolute"
                fiInfoPosition="top"
                tooltipClass="fi-rounded-white-tooltip"
                tooltipTextAlignment="center"
                [isIconTooltipShown]="false"
                >
                <span [innerHTML]="checklistStatusData.notStartedCount"></span>
              </fi-info-icon>
            }
          </div>
        </div>
        `,
    styleUrls: ['./checklist-status-row.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'checklist-status-row' },
    standalone: false,
})
export class FiChecklistStatusRowComponent implements OnInit {
    @Input() checklistStatusData: IChecklistStatusProgressData;
    @Input() isTooltipAvailable: boolean = true;

    @ViewChild('completedEl', { static: true }) completedElRef: ElementRef<HTMLElement>;
    @ViewChild('inProgressEl', { static: true }) inProgressElRef: ElementRef<HTMLElement>;
    @ViewChild('notStartedEl', { static: true }) notStartedElRef: ElementRef<HTMLElement>;

    constructor(private renderer: Renderer2) {}

    ngOnInit() {
        this.setProgressItemsSize();
    }

    private setProgressItemsSize() {
        const completedItemWidth: number = this.getItemWidthPercent(this.checklistStatusData.completedCount);
        this.renderer.setStyle(this.completedElRef.nativeElement, 'width', `${completedItemWidth}%`);

        const inProgressItemWidth: number =
            this.getItemWidthPercent(this.checklistStatusData.inProgressCount) + completedItemWidth;
        this.renderer.setStyle(this.inProgressElRef.nativeElement, 'width', `${inProgressItemWidth}%`);

        const notStartedItemWidth: number =
            this.getItemWidthPercent(this.checklistStatusData.notStartedCount) + inProgressItemWidth;
        this.renderer.setStyle(this.notStartedElRef.nativeElement, 'width', `${notStartedItemWidth}%`);
    }

    private getItemWidthPercent(count: number): number {
        const countSum: number =
            this.checklistStatusData.completedCount +
            this.checklistStatusData.inProgressCount +
            this.checklistStatusData.notStartedCount;
        return (count / countSum) * 100;
    }

    protected readonly FiInfoIconMode = FiInfoIconMode;
}
